import React, { useState, useEffect, useRef } from 'react'
import {Form, Button, DropdownButton, Dropdown, ProgressBar, Spinner} from "react-bootstrap";
import axios from 'axios';
import * as signalR from "@microsoft/signalr";
import { Container } from 'reactstrap';
import './AstraWelcome.css';
import {useTranslation} from "react-i18next";

function AstraWelcome({droneCount}) {


    return(
        <div className='astra-welcome'>
            <div>Вся информация о подлючениях и актуальные версии прошивки в <a href='https://wiki.csky.space/wiki/astra/manual'>WIKI.</a></div>
            { droneCount <= 0 ? <div>Заметил, что у тебя еще нет устройств, инструкция по сборке и подписка находятся по <a href='https://csky.space/astra'>ссылке</a></div> : <></>}
        </div>
    )
}

export default AstraWelcome;